import { CommonModule } from '@angular/common';
import { NgModule }  from '@angular/core';
import { FormsModule } from '@angular/forms';

import { AlmEditableModule } from 'ngx-widgets';
import { AutosizeDirective } from './../autosize/autosize.directive';
import { ClickOutModule } from './../clickout/clickout.module';
import { InlineInputComponent } from './inlineinput.component';


export class InlineInputModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [ InlineInputComponent, AutosizeDirective ],
  imports: [
    AlmEditableModule,
    ClickOutModule,
    CommonModule,
    FormsModule
  ],
  exports: [ InlineInputComponent ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
